var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"waste-pill",class:`waste-pill--${_vm.status}`},[_c('span',{staticClass:"waste-pill__dot",style:(_vm.dotStyle),attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t(_vm.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }